import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: true
})
export class TruncatePipe implements PipeTransform {
    transform(value: string | null | undefined, limit = 30): { text: string, isTruncated: boolean } {
        if (value === null || value === undefined) {
            return { text: '', isTruncated: false };
        }

        const isTruncated = value.length > limit;
        const truncatedText = isTruncated ? value.substring(0, limit).trimEnd() + '...' : value;

        return { text: truncatedText, isTruncated };
    }
}
